import { getFileIndex } from "@root/store/selectors/entities";
import { useSelector } from "react-redux";
import { ChatBotTextArea } from "./ChatBotTextArea";
import { StayledInputContainer } from "@root/components/dashboard/style";
import { useRef } from "react";

export function ChatBotInput({
  fileContainerRef,
  submitHandler,
  onChangehandler,
  input,
  onSubmit,
  loading,
  setInput,
  pid,
  name,
  px = 0,
  onSend,
  stopPolling,
  currentStatus,
  ...props
}: any) {
  const inputRef: any = useRef(null);
  const fileIndex = useSelector(getFileIndex);

  return (
    <StayledInputContainer {...props} px={px}>
      <ChatBotTextArea
        onSubmit={onSubmit}
        fileIndex={fileIndex}
        onSend={onSend || submitHandler}
        inputRef={inputRef}
        onChangehandler={onChangehandler}
        input={input}
        loading={loading}
        name={name}
        pid={pid}
        stopPolling={stopPolling}
        currentStatus={currentStatus}
      />
    </StayledInputContainer>
  );
}
